export const GA_EVENT_PAGE_VIEW = 'page_view';
export const GA_EVENT_ADMIN_ACCOUNT_MANAGEMENT_PAGE_VIEW = 'admin_account_management_page_view';
export const GA_EVENT_ADMIN_CATALOG_TYPES_PAGE_VIEW = 'admin_catalog_types_page_view';
export const GA_EVENT_ADMIN_CATALOGS_PAGE_VIEW = 'admin_catalogs_page_view';
export const GA_EVENT_ADMIN_DEPARTMENTS_PAGE_VIEW = 'admin_departments_page_view';
export const GA_EVENT_ADMIN_OUTAGE_NOTIFICATIONS_PAGE_VIEW = 'admin_outage_notifications_page_view';
export const GA_EVENT_ADMIN_PRODUCT_CONTRACT_GROUPS_PAGE_VIEW = 'admin_product_contract_groups_page_view';
export const GA_EVENT_ADMIN_PRODUCTS_PAGE_VIEW = 'admin_products_page_view';
export const GA_EVENT_ADMIN_CREATE_OR_EDIT_CATALOG_PAGE_VIEW = 'admin_create_or_edit_catalog_page_view';
export const GA_EVENT_ADMIN_FIND_AND_DELETE_CODES_PAGE_VIEW = 'admin_find_and_delete_codes_page_view';
export const GA_EVENT_ADMIN_MASS_CREATE_CATALOG_CLICK = 'admin_mass_create_catalog_click';

const routeEventMap = {
  '/catalogs': GA_EVENT_ADMIN_CATALOGS_PAGE_VIEW,
  '/catalogs/new': GA_EVENT_ADMIN_CREATE_OR_EDIT_CATALOG_PAGE_VIEW,
  '/catalogs/findDeleteProductCodes': GA_EVENT_ADMIN_FIND_AND_DELETE_CODES_PAGE_VIEW,
  '/accounts': GA_EVENT_ADMIN_ACCOUNT_MANAGEMENT_PAGE_VIEW,
  '/catalogTypes': GA_EVENT_ADMIN_CATALOG_TYPES_PAGE_VIEW,
  '/departments': GA_EVENT_ADMIN_DEPARTMENTS_PAGE_VIEW,
  '/notifications': GA_EVENT_ADMIN_OUTAGE_NOTIFICATIONS_PAGE_VIEW,
  '/productContractGroups': GA_EVENT_ADMIN_PRODUCT_CONTRACT_GROUPS_PAGE_VIEW,
  '/products': GA_EVENT_ADMIN_PRODUCTS_PAGE_VIEW
};

/**
 *
 * @method sendEventToGA
 * @desc Send custom event data to Google Analytics
 * @param {object} eventName the event to send
 * @param {object} params the additional parameters to send with the event
 */
export const sendEventToGA = (eventName, params = {}) => {
  const finalParams = { ...params };
  if (eventName === GA_EVENT_PAGE_VIEW && !params.pageViewType) {
    const pageViewType = routeEventMap[params.pathname] || null;

    if (!pageViewType) {
      return;
    }

    finalParams.pageViewType = pageViewType;
  }

  window.dataLayer.push({ event: eventName, ...finalParams });
};
